<div class="lds-facebook" *ngIf="running">
  <div></div>
  <div></div>
  <div></div>
</div>